module.exports = __webpack_public_path__ + "img/IMG-20200319-WA0113.4f9288c7.jpg";